import { Component, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '../../common/BaseComponent';

@Component({
  selector: 'app-password-reset-success',
  templateUrl: './password-reset-success.component.html',
  styles: [
  ]
})
export class PasswordResetSuccessComponent extends BaseComponent implements OnInit {

  constructor(
    injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
  }

  onSubmit() {
    this.checkRedirectUrl();
  }

}
